export enum CategorieAuditBpf {
  Conforme = 'Conforme',
  Alerte = 'Alerte',
  Bloquante = 'Bloquante',
  Exclue = 'Exclue',
}

/**
 * Cible précise vers laquelle rediriger pour corriger une erreur d'audit — pointe directement
 * sur l'entité à corriger (le contrat, le formateur, l'inscription, la séance concernée) plutôt
 * que sur un onglet générique de la session, quand cette entité est identifiable. Les variantes
 * `session-*` restent des onglets de la fiche session : elles couvrent les cas où aucune entité
 * précise n'existe encore à corriger (ex : aucune inscription du tout, aucune séance du tout).
 * Voir SessionsNavService / DossiersFinancementNavService / FormateursNavService /
 * InscriptionsNavService / SeancesNavService / FormationsNavService pour les navigators réels
 * associés. `formation` cible la fiche formation (onglet général) — niveau/spécialité BPF non
 * renseignés (voir export-bpf.component.ts pour l'hypothèse "formation simple" retenue).
 */
export type BpfAuditNavigation =
  | { type: 'session-general'; idSession: number }
  | { type: 'session-inscriptions'; idSession: number }
  | { type: 'session-seances'; idSession: number }
  | { type: 'session-tarifs'; idSession: number }
  | { type: 'contrat-session'; idDossierFinancement: number; idSession: number }
  | { type: 'inscription'; idInscription: number }
  | { type: 'formateur'; idFormateur: number }
  | { type: 'seance'; idSession: number; idSeance: number }
  | { type: 'formation'; idFormation: number };

export interface BpfAuditErreur {
  message: string;
  navigation: BpfAuditNavigation;
}

export interface BpfAuditSession {
  idSession: number;
  libelleSession: string;
  categorie: CategorieAuditBpf;
  /** Gestionnaire administratif de la session, à défaut celui de sa formation ; null si aucun. */
  idGestionnaireAdministratif: number | null;
  libelleGestionnaireAdministratif: string | null;
  erreurs: BpfAuditErreur[];
}

export interface BpfAuditCompteurs {
  conforme: number;
  alerte: number;
  bloquante: number;
  exclue: number;
}

export interface BpfAuditGlobal {
  compteurs: BpfAuditCompteurs;
  sessions: BpfAuditSession[];
}
